import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import {
  GallerySkuFilter,
  parseGallerySkuFilter,
} from 'utils/gallerySkuFilter';

/**
 * SKU filter the company gallery is restricted to, taken from {@code ?skuIds=}
 * and {@code ?skuTags=}. Empty object when the route carries no filter.
 */
export const useGallerySkuFilter = (): GallerySkuFilter => {
  const { search } = useLocation();
  return useMemo(() => parseGallerySkuFilter(search), [search]);
};
